import refundActions from "./actions";

const initialState = {
    refundList: [],
    // Mirrors the pagination envelope the list endpoint returns. The worklist is paged on the
    // server, so the page the user is on has to live here rather than being sliced out of a
    // full result set in the component.
    refundPagination: { page: 1, limit: 25, total: 0, totalpages: 0 },
    // Per-row rejections from "Mark as Refunded". Kept in state so the dialog can stay open and
    // show which receipts were refused -- the whole selection is rejected together, so these are
    // the reason nothing was written.
    markRefundErrors: [],
    // The dry run: { total, willapply, errors, token, result }. Null until a file is uploaded,
    // and cleared once the confirm succeeds or the dialog closes.
    bulkRefundPreview: null
};

const refundReducer = (state = initialState, action) => {
    switch (action.type) {
        case refundActions.SET_REFUND_LIST:
            return {
                ...state,
                refundList: action.payload?.result || [],
                refundPagination: action.payload?.pagination || initialState.refundPagination
            };

        case refundActions.SET_MARK_REFUND_ERRORS:
            return {
                ...state,
                markRefundErrors: action.payload || []
            };

        case refundActions.SET_BULK_REFUND_PREVIEW:
            return {
                ...state,
                bulkRefundPreview: action.payload
            };

        case refundActions.CLEAR_BULK_REFUND_PREVIEW:
            return {
                ...state,
                bulkRefundPreview: null
            };

        default:
            return state;
    }
};

export default refundReducer;
